import type { Ref } from 'vue'
import type { Extra } from '@/components/orders/ExtrasSelector.vue'
import type { ExtendedMenuItem, MenuItemVariant } from '@/types/order'
import type { OrderPerson, PersonOrderItem } from '@/composables/useMultipleDiners'

interface UseOrderItemDetailsAdderOptions {
  persons: Ref<OrderPerson[]>
  activePersonIndex: Ref<number>
  selectedItem: Ref<ExtendedMenuItem | null>
  selectedVariant: Ref<MenuItemVariant | null>
  itemNotes: Ref<string>
  itemSpecialNote: Ref<string>
  itemExtras: Ref<Extra[]>
  showItemModal: Ref<boolean>
  getVariantPrice: (item: ExtendedMenuItem, variant: MenuItemVariant | null) => number
}

export function useOrderItemDetailsAdder(options: UseOrderItemDetailsAdderOptions) {
  const addItemWithDetails = () => {
    if (!options.selectedItem.value) {
      return
    }

    const variant = options.selectedVariant.value
    const itemPrice = options.getVariantPrice(options.selectedItem.value, variant)

    const menuItemId = Number(options.selectedItem.value.id || 0)
    const variantId = variant ? Number(variant.id) : null

    const finalNote = options.itemSpecialNote.value || options.itemNotes.value

    const newItem: PersonOrderItem = {
      menu_item_id: menuItemId,
      variant_id: variantId,
      quantity: 1,
      unit_price: itemPrice,
      notes: finalNote || '',
      special_instructions: '',
      extras: options.itemExtras.value.length > 0 ? [...options.itemExtras.value] : []
    }

    const activePerson = options.persons.value[options.activePersonIndex.value]
    if (activePerson) {
      activePerson.items.push(newItem)
    }

    options.showItemModal.value = false
    options.itemNotes.value = ''
    options.itemSpecialNote.value = ''
    options.itemExtras.value = []
  }

  return {
    addItemWithDetails
  }
}
